<template>
  <div class="card-body py-3">
    <h3 class="mb-0 t-500">
      Disciplines
      <editable v-if="isLoaded && canEdit && !isEmpty(disciplines)" :text="addOrEditText(disciplines.length)"
        @create="handleEdit()"
        @cancel="handleEdit()">
      </editable>

      <i v-if="isLoaded && (isEmpty(disciplines) || !canEdit)" class="fa fa-star d-block pull-right t-placeholder"></i>
    </h3>

    <!-- render content when is loaded -->
    <template v-if="isLoaded">
      <!-- no discipline present and can edit-->
      <p v-if="isEmpty(disciplines) && canEdit" class="mb-0 mt-4 text-center">
        <i class="fa fa-plus d-block t-secondary"></i>
        <a href="#" @click.prevent="handleEdit()" class="t-sm">Add your disciplines</a>
      </p>

      <!--  no discipline present and cannot edit -->
      <p v-if="isEmpty(disciplines) && !canEdit" class="mb-0 mt-1 t-sm t-secondary">
        No disciplines added.
      </p>

      <!-- render disciplines -->
      <template v-if="!isEmpty(disciplines) && !isEditMode">
        <ul v-for="(d, index) in disciplines" :key="index" class="list-unstyled mb-0 clearfix" :class="{ 'mt-3' : index === 0 }">
          <li v-for="(sub, i) in d.sub_disciplines" :key="i" class="badge badge-pill badge-secondary--white bd-radius pull-left mr-2 mb-2 word-overflow">
            {{ sub.name }}
          </li>
        </ul>
      </template>
    </template>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import Editable from '@/components/shared/Editable'

export default {
  name: 'researcherDiscipline',
  components: {
    Spinner,
    Editable
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isEditMode: false,
      error: null
    }
  },
  computed: {
    disciplines () {
      return this.researcher.disciplines
    }
  },
  methods: {
    handleEdit () {
      this.$events.$emit('modal:discipline:open', this.disciplines)
    }
  }
}
</script>
